import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Actionbar from 'components/organisms/Snackbars/Actionbar/Actionbar';

const StyledCollectionEntitiesActionbar = styled(Actionbar)` 
  ${ComponentStyles}
`;

StyledCollectionEntitiesActionbar.propTypes = {
  theme: PropTypes.object
};

export default StyledCollectionEntitiesActionbar;
